import * as React from "react";

import { BackIconBody, BackIconRoot, RoundedButton } from "./RoundedBackButton.styles";

interface RoundedBackButtonProps {
    onClick?: () => void;
}

export function RoundedBackButton(props: RoundedBackButtonProps): JSX.Element {
    return (
        <RoundedButton onClick={props.onClick}>
            <BackIcon />
        </RoundedButton>
    );
}

function BackIcon(): JSX.Element {
    return (
        <BackIconRoot>
            <BackIconBody />
        </BackIconRoot>
    );
}
